<template>
  <div class="users">
    <h3 class="d-flex w-100 align-items-center justify-content-between">
      Випускники

      <b-button
        @click="openInviteModal"
        class="add-user d-none"
        variant="primary"
      >
        <b-icon-plus />
        Запросити випускника
      </b-button>
      <b-button
        @click="openTelegramBroadcastModal"
        class="telegram-broadcast"
        variant="secondary"
      >
        <b-icon-chat-fill />
        Написати усім в Telegram
      </b-button>
    </h3>
    <b-card>
      <b-tabs content-class="mt-3">
        <b-tab active>
          <template #title>
            <b-icon-check-circle-fill />
            &nbsp;
            <strong>Активні</strong>
          </template>
          <div class="pb-4">
            <b-button
              class="users__filter-toggle d-inline-flex mb-4 align-items-center"
              :class="{ expanded: filter.expanded }"
              @click="filter.expanded = !filter.expanded"
            >
              <b-icon-filter
                class="d-inline-block"
                style="margin-right: 10px"
              />
              Фільтр
              <span class="icon">
                <b-icon-chevron-down />
              </span>
            </b-button>
            <div class="users__filter mb-4" v-show="filter.expanded">
              <div class="row">
                <div class="col-12 col-md-4">
                  <div class="filter-group">
                    <div class="title"><b-icon-folder /> Категорія</div>
                    <v-select
                      :options="categoryOptions"
                      placeholder="Усі категорії"
                      :reduce="(option) => option.value"
                      v-model="filter.category"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-8">
                  <div class="filter-group">
                    <div class="title"><b-icon-tag /> Теги</div>
                    <v-select
                      v-model="filter.tags"
                      placeholder="Усі теги"
                      :reduce="(option) => option.value"
                      multiple
                      :options="tagOptions"
                    />
                  </div>
                </div>
              </div>
              <div class="cta text-end pt-3">
                <b-button
                  variant="outline-primary"
                  @click="fetchActiveUsers(true)"
                >
                  Застосувати фільтри
                </b-button>
              </div>
            </div>
            <b-overlay
              :show="isLoading"
              spinner-variant="primary"
              color="#fff"
              rounded="lg"
            >
              <userItem
                v-for="u in active_users"
                :key="u.id"
                :u="u"
                :tags="tags"
              />
              <div class="load-more mt-4">
                <b-button
                  @click="fetchActiveUsers"
                  class="w-100"
                  variant="outline-primary"
                  v-if="!is_last_page.active"
                >
                  <span v-if="!isLoading"> Завантажити ще </span>
                  <span v-else> Заваниаження.... </span>
                </b-button>
              </div>
            </b-overlay>
          </div>
        </b-tab>
        <b-tab @click="invitedTabActivation">
          <template #title>
            <b-icon-hourglass />
            &nbsp;
            <strong>Запрошені</strong>
          </template>
          <div class="py-4">
            <b-overlay
              :show="isLoading"
              spinner-variant="primary"
              color="#fff"
              rounded="lg"
            >
              <userItem
                v-for="u in invited_users"
                :key="u.id"
                :u="u"
                :tags="tags"
              />
              <div class="load-more mt-4">
                <b-button
                  @click="getInvitedUsers(false)"
                  class="w-100"
                  variant="outline-primary"
                  v-if="!is_last_page.invited"
                >
                  <span v-if="!isLoading"> Завантажити ще </span>
                  <span v-else> Заваниаження.... </span>
                </b-button>
              </div>
            </b-overlay>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <inviteModal ref="inviteUserModal" :role="'user'" />
    <broadcastTelegram ref="telegramBroadcastModal" />
  </div>
</template>

<script>
import inviteModal from "@/components/admin/modals/invite-user.vue";
import broadcastTelegram from "@/components/admin/modals/broadcast-telegram.vue";
import userItem from "@/components/admin/list-items/user-list-item.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isLoading: false,
      active_users: [],
      invited_users: [],
      perPage: 96,
      page: 1,
      is_last_page: {
        invited: false,
        active: false,
      },
      last_visible: {
        invited: null,
        active: null,
      },
      filter: {
        expanded: false,
        category: null,
        tags: [],
      },
    };
  },
  components: {
    inviteModal,
    userItem,
    broadcastTelegram,
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      tags: "tags",
    }),
    categoryOptions() {
      let options = [];
      if (this.categories && this.categories.length) {
        options = this.categories.map((el) => {
          return {
            label: el.name,
            value: el.id,
          };
        });
      }

      return options;
    },
    tagOptions() {
      let options = [];
      if (this.tags.length) {
        options = this.tags.map((el) => {
          return {
            label: el.name,
            value: el.id,
          };
        });
      }

      return options;
    },
  },
  methods: {
    async fetchActiveUsers(filter) {
      if (filter == true) {
        this.active_users = [];
      }
      this.isLoading = true;
      let args = {
        collectionName: "users",
        where: ["role", "==", "user"],
        limitBy: this.perPage,
      };

      //Filters
      if (this.filter.category) {
        args["where_cat"] = ["category", "==", this.filter.category];
      }
      if (this.filter.tags.length) {
        args["where_tag"] = ["tags", "array-contains-any", this.filter.tags];
      }
      if (this.last_visible.active && filter == false) {
        args["startAfter"] = this.last_visible.active;
      }
      let result = await this.$db.getCollection(args);
      result.docs.forEach((doc) => {
        this.active_users.push(doc);
      });
      if (result.docs.length < this.perPage) {
        this.is_last_page.active = true;
      }

      this.last_visible.active = result.lastVisible;
      console.log(result);
      this.isLoading = false;
    },
    openInviteModal() {
      this.$refs.inviteUserModal.showInviteModal = true;
    },
    openTelegramBroadcastModal() {
      this.$refs.telegramBroadcastModal.show = true;
    },
    invitedTabActivation() {
      if (!this.invited_users.length) {
        this.getInvitedUsers();
      }
    },
    async getInvitedUsers() {
      this.isLoading = true;
      let args = {
        collectionName: "users",
        where: ["role", "==", "user"],
        where2: ["activated", "==", false],
        limitBy: this.perPage,
      };
      if (this.last_visible.invited) {
        args["startAfter"] = this.last_visible.invited;
      }
      let result = await this.$db.getCollection(args);
      result.docs.forEach((doc) => {
        this.invited_users.push(doc);
      });
      this.last_visible.invited = result.lastVisible;
      if (result.docs.length < this.perPage) {
        this.is_last_page.invited = true;
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.fetchActiveUsers();
  },
};
</script>

<style lang="scss" scoped>
h3 {
  .btn {
    margin-left: auto;
    svg {
      margin-right: 8px;
      line-height: 1;
    }
    &.telegram-broadcast {
      background: #0088cc;
      border-color: #0088cc;
      &:hover {
        background: lighten(#0088cc, 5%);
        border-color: lighten(#0088cc, 5%);
      }
    }
  }
}
.users {
  &__filter-toggle {
    color: var(--primary-color) !important;
    background: #e9e9e9 !important;
    border: none;
    font-size: 14px;
    padding: 6px 8px;

    // box-shadow: 0px 3px 4px 0px rgba(#000, 0.2) !important;
    span {
      display: inline-block;
      margin-left: 22px;
      font-size: 12px;
    }
    &:hover {
      background: rgba(var(--primary-color-rgb), 0.2) !important;
    }
    &.expanded {
      background: var(--primary-color) !important;
      color: #fff !important;
      box-shadow: inset 0px -3px 6px 0px rgba(#000, 0.1) !important;
      .icon {
        transform: scaleY(-1);
      }
    }
  }
  &__filter {
    border-top: 1px solid var(--primary-color);
    box-shadow: 0px 10px 20px 0px rgba(#000, 0.1);
    padding: 12px;
    margin-bottom: 40px !important;
    position: relative;
    &::before {
      content: "";
      display: block;
      width: 16px;
      height: 16px;
      background: #fff;
      position: absolute;
      top: -9px;
      left: 42px;
      border-top: 1px solid var(--primary-color);
      border-left: 1px solid var(--primary-color);
      transform: rotate(45deg);
    }
    .btn {
      font-size: 14px;
      line-height: 1;
    }

    .title {
      font-size: 14px;
      color: var(--primary-color);
      margin-bottom: 5px;
    }
  }
}
</style>
